/* ===== Подключение Компонентов React ===== */
import { useState } from "react";
import { Link } from "react-router-dom";

/* ===== Подключение Локальной Базы Данных ===== */
import FormDB from "./formdb";

/* ===== Подключение стилей ===== */
import s from "./Fomrs.module.scss";

function FormBase({ fields = FormDB, hideMessage = false, selected = null, promo, asModal = false }) {

    /* === Подключаем состояние (Базу данных, Вариант) === */
    const [values, setValues] = useState({ consent: false });

    /* === Подключаем Показ состояния отправки в блок === */
    const [formStatus, setFormStatus] = useState({
        type: "",
        message: "",
    });

    /* === Проверка на валидатность форм === */
    const validators = {
        name: /^[a-zA-Zа-яА-ЯёЁ\s-]{2,}$/,      // только буквы, пробел, дефис
        phone: /^\+?\d{10,15}$/,               // только цифры, можно +
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,   // стандартный email
    };

    /* === Подсветка поля с ошибкой === */
    const [errors, setErrors] = useState({});

    /* === функция для проверки полей === */
    const validateField = (name, value) => {
        if (!value?.trim()) return false;

        switch (name) {
            case "name":
                return validators.name.test(value.trim());

            case "phone":
                return validators.phone.test(String(value).replace(/\D/g, ""));

            case "email":
                return validators.email.test(value.trim());

            default:
                return true;
        }
    };

    /* === Настройка поведения для номера телефона добавляем +7 для РФ === */
    const normalizePhoneRU = (raw) => {
        let s = String(raw || "").trim();

        // оставляем только цифры и +
        s = s.replace(/[^\d+]/g, "");

        // если человек начал с 8 — меняем на +7
        if (s.startsWith("8")) s = "+7" + s.slice(1);

        // если начал с 9 (типично для моб. номера без кода страны) — добавим +7
        if (/^9\d{0,}$/.test(s)) s = "+7" + s;

        // если вообще без плюса и начинается не с 7/8/9 — просто оставим цифры (на твой вкус)
        // но чаще лучше тоже загонять в +7 если это РФ:
        if (/^\d+$/.test(s) && !s.startsWith("7")) {
            // например ввёл 915... без плюса — уже поймали выше
            // если ввёл 123 — не трогаем, чтобы не бесить
        }

        return s;
    };

    /* === Изменение поведения телефона форматирование === */
    const formatPhoneRU = (s) => {
        const digits = String(s || "").replace(/\D/g, "");
        // ожидаем 11 цифр: 7XXXXXXXXXX
        if (digits.length === 0) return "";
        let d = digits;

        // если 10 цифр и начинается с 9 — добавим 7
        if (d.length === 10 && d.startsWith("9")) d = "7" + d;

        if (d[0] !== "7") return "+" + d; // на всякий случай

        const a = d.slice(1, 4);
        const b = d.slice(4, 7);
        const c = d.slice(7, 9);
        const e = d.slice(9, 11);

        let out = "+7";
        if (a) out += ` (${a}`;
        if (a.length === 3) out += ")";
        if (b) out += ` ${b}`;
        if (c) out += `-${c}`;
        if (e) out += `-${e}`;
        return out;
    };

    /* === 
      Правила для полей ввода:
      v - Старые значения
      ...v - Копируем их
      [e.target.name] - имя поля(name, phone, email)
      e.target.value - что ввёл пользователь
    === */

    const onChange = (e) => {
        const { name, value } = e.target;

        /* ✅ только для телефона применяем normalize + format */
        if (name === "phone") {
            const normalized = normalizePhoneRU(value);
            const formatted = formatPhoneRU(normalized);

            setValues((v) => ({ ...v, phone: formatted }));
            setErrors((er) => ({ ...er, phone: false }));
            return;
        }

        setValues((v) => ({ ...v, [name]: value }));
        setErrors(e => ({ ...e, [name]: false }));
    };

    /* === Делаем проверку полей и на антиспан === */
    const handleSubmit = async (e) => {
        e.preventDefault();

        setErrors({}); /* ✅ очищаем старые ошибки */

        /* === антиспам honeypot: если заполнено — бот === */
        if (values.website) return;

        /* === Обязательное ФИО === */
        if (!values.name?.trim() || !validators.name.test(values.name.trim())) {
            setErrors((e) => ({ ...e, name: true }));
            setFormStatus({
                type: "error",
                message: "Вы не заполнили поле ФИО, или ввели не корректно",
            });
            return;
        }

        /* ✅ телефон: чистим от скобок/дефисов/пробелов */
        const phoneOnlyDigits = (values.phone || "").replace(/\D/g, "");

        /* === Обязательное поле телефон === */
        if (phoneOnlyDigits.length < 11) {
            setErrors((e) => ({ ...e, phone: true }));
            setFormStatus({
                type: "error",
                message: "Вы не заполнили поле Телефон, или ввели не корректно",
            });
            return;
        }

        /* ✅ email: если он обязателен — проверяем. Если не обязателен — только если введён. */
        if (values.email?.trim() && !validators.email.test(values.email.trim())) {
            setErrors({ email: true });
            setFormStatus({ type: "error", message: "Введите корректный email" });
            return;
        }

        /* === обязательная галка === */
        if (!values.consent) {
            setErrors({ consent: true });
            setFormStatus({
                type: "error",
                message: "Вы не поставили галочку согласия, Необходимо согласие",
            });
            return;
        }

        /* === Когда все заполнено правильно === */
        try {
            setFormStatus({ type: "loading", message: "Отправляем..." });

            const fd = new FormData();
            fd.append("name", values.name || "");
            fd.append("phone", values.phone || "");
            fd.append("email", values.email || "");     // не обязательно
            fd.append("message", values.message || "");
            fd.append("website", values.website || ""); // honeypot
            fd.append("consent", values.consent ? "1" : "0");

            // ✅ ВОТ СЮДА ДОБАВЛЯЕМ выбранный товар (если он есть)
            if (selected) {
                fd.append("productTitle", selected.productTitle || "");
                fd.append("qty", String(selected.qty ?? ""));
                fd.append("pricePerLiter", String(selected.pricePerLiter ?? ""));
                fd.append("total", String(selected.total ?? ""));
                fd.append("sku", String(selected.sku ?? ""));
            }

            {/* === ✅ промо/акция (если открыто из блока акций) ===*/ }
            if (promo) {
                fd.append("promoId", String(promo.id ?? ""));
                fd.append("promoTitle", String(promo.title ?? ""));
                fd.append("promoSubtitle", String(promo.subtitle ?? ""));
            }

            const res = await fetch("/api/send.php", {
                method: "POST",
                body: fd,
            });

            const text = await res.text();
            let data = {};
            try { data = JSON.parse(text); } catch { throw new Error("Server non-JSON"); }

            if (!res.ok || !data.success) {
                throw new Error(data.error || "Send failed");
            }

            setFormStatus({
                type: "success",
                message: "Сообщение отправлено. В ближайшее время с вами свяжется наш специалист.",
            });

            // опционально: очистить форму
            setValues({ consent: false });

        } catch (err) {
            setFormStatus({
                type: "error",
                message: err?.message || "Не удалось отправить. Попробуйте позже.",
            });
        }
    };

    /* === Отображение поля textarea === */
    const visibleFields = hideMessage ? fields.filter((f) => f.name !== "message" && f.type !== "textarea") : fields;

    const RootTag = asModal ? "div" : "section";

    return (
        <RootTag 
        id={asModal ? undefined : "order-form"} 
        className={s.formContainerBase}
    >
            <div className={s.formContentBase}>
                <div className={s.formTitleBase}>
                    {promo ? "Заявка на акцию " : selected ? "Заявка на заказ" : "Форма заявки "}
                    {promo
                        ? "Оставьте контакты — закрепим условия и перезвоним."
                        : "Оставьте заявку — и получите топливо уже завтра."}
                </div>

                {/* === Выше формы товарная часть === */}
                {selected && (
                    <div className={s.orderPreview}>
                        <div><b>Товар:</b> {selected.productTitle}</div>
                        <div><b>Количество:</b> {selected.qty} л</div>
                        <div><b>Цена/л:</b> {selected.pricePerLiter} ₽</div>
                        <div><b>Итого:</b> {selected.total} ₽</div>
                        <div><b>Артикул:</b> {selected.sku}</div>
                    </div>
                )}

                {/* === Акции === */}
                {promo && (
                    <div className={s.orderPreview}>
                        <div><b>Акция:</b> {promo.title}</div>
                        {promo.subtitle ? <div><b>Условие:</b> {promo.subtitle}</div> : null}
                    </div>
                )}



                {/* === Сама форма отправки === */}
                <form id="leadFormBase" onSubmit={handleSubmit} className={s.formBase} action="#" method="POST">
                    {/* === Массив для полей === */}
                    {(visibleFields || []).map(f => {

                        if (f.type === "textarea") {
                            return (
                                <textarea
                                    key={f.name}
                                    name={f.name}
                                    placeholder={f.placeholder}
                                    value={values[f.name] ?? ""}
                                    onChange={onChange}
                                />
                            );
                        }

                        return (
                            <input
                                className={errors[f.name] ? s.inputError : ""}
                                key={f.name}
                                type={f.type}
                                name={f.name}
                                placeholder={f.placeholder}
                                value={values[f.name] ?? ""}
                                onChange={onChange}
                                {...(f.inputMode ? { inputMode: f.inputMode } : {})}
                            />
                        );
                    })}

                    <input
                        type="text"
                        name="website"
                        value={values.website ?? ""}
                        onChange={(e) =>
                            setValues(v => ({ ...v, website: e.target.value }))
                        }
                        style={{ display: "none" }}
                        autoComplete="off"
                    />
                </form>
            </div>
            <div className={s.formFooter}>
                <div className={s.formCheckbox}>
                    <label className={s.checkbox}>
                        <input
                            type="checkbox"
                            name="consent"
                            checked={values.consent ?? false}
                            onChange={(e) =>
                                setValues(v => ({ ...v, consent: e.target.checked }))
                            }
                        />
                        <span className={s.robotCheck}>
                            <span> Я даю согласие на обработку персональных данных и соглашаюсь с{" "}</span>
                             <Link to="/privacy" target="_blank" rel="noreferrer">Политикой</Link>
                        </span>
                    </label>
                </div>
                {formStatus.message && (
                    <div className={`${s.formConsole} ${formStatus.type === "error" ? s.error : s.success}`}>
                        {formStatus.message}
                    </div>
                )}
                <div className={s.formBtn}>
                    <button type="submit" className={s.btn} form="leadFormBase">Получить цену</button>
                </div>
            </div>
        </RootTag>
    )
}

export default FormBase;